module.exports = __webpack_public_path__ + "img/sending_1.84a4833e.png";